export default __webpack_public_path__ + "static/go-business-5dd52d3a05f49d547ae7d8a36a7cd41e.png";